/**
 * 品牌支付配置入口
 */
import type { BrandPaymentConfig, ChapterConfig, PayPageConfig, SubscribePageConfig } from '../types'
import { rocnovelPaymentConfig } from './rocnovel'
import { ocereadPaymentConfig } from './oceread'
import { ficmoonPaymentConfig } from './ficmoon'
import { novelarcPaymentConfig } from './novelarc'
import { storyellaPaymentConfig } from './storyella'
import { silktalePaymentConfig } from './silktale'
import { pearlaPaymentConfig } from './pearla'
import { fictoraPaymentConfig } from './fictora'
import { marinovelPaymentConfig } from './marinovel'
import { loadBrandConfig } from '@/utils/loadBrandConfig'

// 导出所有品牌配置
export { rocnovelPaymentConfig } from './rocnovel'
export { ocereadPaymentConfig } from './oceread'
export { ficmoonPaymentConfig } from './ficmoon'
export { novelarcPaymentConfig } from './novelarc'
export { storyellaPaymentConfig } from './storyella'
export { silktalePaymentConfig } from './silktale'
export { pearlaPaymentConfig } from './pearla'
export { fictoraPaymentConfig } from './fictora'
export { marinovelPaymentConfig } from './marinovel'

/**
 * 获取当前品牌的完整支付配置
 */
export function getPaymentConfig(): BrandPaymentConfig {
  return loadBrandConfig({
    rocnovel: rocnovelPaymentConfig,
    oceread: ocereadPaymentConfig,
    ficmoon: ficmoonPaymentConfig,
    novelarc: novelarcPaymentConfig,
    storyella: storyellaPaymentConfig,
    silktale: silktalePaymentConfig,
    pearla: pearlaPaymentConfig,
    fictora: fictoraPaymentConfig,
    marinovel: marinovelPaymentConfig,
  })
}

/**
 * 获取当前品牌的充值页面配置
 */
export function getPayPageConfig(): PayPageConfig {
  return getPaymentConfig().pay
}

/**
 * 获取当前品牌的订阅页面配置
 */
export function getSubscribePageConfig(): SubscribePageConfig {
  return getPaymentConfig().subscribe
}

/**
 * 获取当前品牌的阅读器弹窗配置
 */
export function getChapterConfig(): ChapterConfig {
  return getPaymentConfig().chapter
}

/**
 * 按场景加载配置的辅助函数
 * 用于组件内加载特定场景的品牌配置
 */
export function loadPaymentConfigByScene<T extends 'pay' | 'subscribe' | 'chapter'>(
  scene: T,
): T extends 'pay' ? PayPageConfig : T extends 'subscribe' ? SubscribePageConfig : ChapterConfig {
  const config = getPaymentConfig()
  return config[scene] as any
}
